import {
  storeToRefs,
  useAppStore,
  useGameStore,
  useHaxiStore,
  useHot,
  useSportsStore,
  useTenantStore,
  useUserStore,
} from '@star/stores';
import { openWebsite } from '@star/utils';
import { closeToast, showConfirmDialog, showFailToast, showLoadingToast, showSuccessToast, showToast } from 'vant';
import { router } from '@/routers';
import { mb_err, mb_t, mb_toast } from '@/plugins/global';
import { ConfigUtils } from '@star/config';
import { helperFGBY } from '@star/helpers';
import { $t2en, i18n } from '@star/languages';
import { G_goLogin, transferThirdGameUrl } from './public_utils';
import {
  GameBigTypesEnum,
  GameMainKeysEnum,
  GameMainTypesEnum,
  LotteryTypeIdEnum,
  serverImgPathMap,
} from '@star/constants';
import { getHotGameImgSrc } from '@/pages/home/index';

// 处理接口返回的游戏图片
export const handleServerGameImg = url => {
  if (url && url !== 'undefined' && url !== 'null') {
    return url;
  } else {
    return '';
  }
};
// 哈希游戏收藏
export const _handleHaXiFavorite = async (data, cb?: any) => {
  const haxiStore = useHaxiStore();
  const { isLogin } = storeToRefs(useUserStore());

  if (!isLogin.value) {
    showToast(mb_t('亲，麻烦请登录哦'));
    return Promise.reject(!1);
  }
  let { play_collection: playCollection } = data;
  const bool = playCollection === 1;
  await haxiStore
    .haxiCollection({ data })
    .then((res: any) => {
      if (res.response_code && res.response_code === '9999') {
        const text = bool ? mb_t('收藏成功') : mb_t('取消收藏成功');
        showToast(text);
        if (cb && typeof cb === 'function') cb(res);
        return Promise.resolve(!0);
      } else {
        const text = bool ? mb_t('收藏失败') : mb_t('取消收藏失败');
        showToast(text);
        return Promise.resolve(!1);
      }
    })
    .catch(() => {
      const text = bool ? mb_t('收藏失败') : mb_t('取消收藏失败');
      showToast(text);
      return Promise.resolve(!1);
    });
};

// 收藏
export const _handleFavorite = async (item, cb, type) => {
  const gameStore = useGameStore();
  const { isLogin } = storeToRefs(useUserStore());

  if (!isLogin.value) {
    return Promise.reject(!1);
  }
  let { play_collection: playCollection } = item;
  const bool = playCollection === 1;
  try {
    const res = await gameStore.setPlayCollection({
      data: {
        ...item,
        type,
      },
    });
    if (res?.response_code === '9999') {
      const text = bool ? mb_t('收藏成功') : mb_t('取消收藏成功');
      setTimeout(() => {
        showSuccessToast(text);
      }, 1500);
      if (cb && typeof cb === 'function') cb(res);
      return Promise.resolve(!0);
    } else {
      const text = bool ? mb_t('收藏失败') : mb_t('取消收藏失败');
      showFailToast(text);
      return Promise.resolve(!1);
    }
  } catch (e) {
    const text = bool ? mb_t('收藏失败') : mb_t('取消收藏失败');
    showFailToast(text);
    return Promise.resolve(!1);
  }
};

export const goMNLotteryGame = item => {
  const { hotData } = useHot();
  const { userInfo } = hotData;
  // TODO 暂时写死,后续拿配置的
  const host = 'http://newmncph5.lg0808.com';
  const lotteryUrl = `${host}/mnlottery?appVersion=1&play_cat=${item.play_cat}&play_name=${item.play_name}&cust_id=${userInfo.value.cust_id}&sub_play_id=${item.sub_play_id}&chat_room=1&play_id=${item.play_id}&token=${userInfo.value.access_token}&type=${item.type}&theme=themeKY28`;
  sessionStorage.setItem('LOTTERY_URL', lotteryUrl);
  router.push(`/lotteryf?title=${item.play_cname}`);
};

// 体育 跳转第三方游戏
export const goTYThirdPlatform = item => {
  const gameStore = useGameStore();
  const { hotData, tResLoc } = useHot();
  const { isFreeUser, userInfo } = hotData;
  let isCommit = false;
  const { isLogin } = storeToRefs(useUserStore());

  if (!isLogin.value) {
    G_goLogin();
    // mb_err('亲，请先登录哦', 2);
    return;
  }
  if (isCommit) {
    mb_err('操作过于频繁', 2);
    return;
  }
  if (isFreeUser.value) {
    mb_err('试玩账号不能进入该游戏、请注册正式会员', 2);
    router.replace('/');
    return;
  }
  if (!item) {
    mb_err('彩种信息缺失', 2);
    return;
  }
  // 黑色主题 im体育 进入滚球页面
  if (['black', 'bigwin'].includes(tResLoc.value) && Number(item.play_id) === 931) {
    if (userInfo.value.fict_flag !== 1) {
      router.push('/game?key=gunqiu');
    } else {
      mb_toast(mb_t('用户权限不足'));
    }
    return;
  }
  let playstate = gameStore.playAllStates[item.play_id];
  if (playstate && playstate.play) {
    if (playstate.play.play_state === 2) {
      mb_err('暂停销售', 2);
      return;
    } else if (playstate.play.play_state === 3) {
      mb_err('停止销售', 2);
      return;
    }
  }
  isCommit = true;
  showLoadingToast({
    message: mb_t('努力加载中'),
    forbidClick: true,
    duration: 0,
    loadingType: 'spinner',
  });
  gameStore
    .checking3Game({
      play_id: item.play_id,
    })
    .then((res: any) => {
      isCommit = false;
      if (res.response_code && res.response_code === '9999') {
        const payload: any = {
          play_id: item.play_id,
          params: item,
        };
        if (item.play_name === 'BTI' || item.play_name === 'SB') {
          payload.data = { type: '1' };
        }
        if (item.play_id === 981) {
          // IM电竞
          payload.data = { type: '1' };
        }
        if (item.play_id === 1313) {
          // PRETTY真人
          payload.data = { type: '1' };
        }
        gameStore
          .get3GameUrl(payload)
          .then((res: any) => {
            closeToast();
            if (res && res.url) {
              const _urlInfo = transferThirdGameUrl(res.url, payload, item);
              setTimeout(() => {
                goLinkGame(_urlInfo);
              }, 300);
            } else {
              showFailToast(mb_t('未获取到三方平台地址'));
            }
          })
          .catch(err => {
            closeToast();
            mb_err(err.toString());
          });
      } else {
        closeToast();
      }
    })
    .catch(err => {
      closeToast();
      isCommit = false;
      if (err) {
        if (err.exMessage) {
          mb_err(err.exMessage.toString());
        } else if (err.info) {
          mb_err(err.info.toString());
        }
      }
    });
};

// 真人 跳转第三方游戏
export const goZRThirdPlatform = async item => {
  const gameStore = useGameStore();
  const sportsStore = useSportsStore();
  const { hotData } = useHot();
  const { isFreeUser } = hotData;
  const { isLogin } = storeToRefs(useUserStore());
  let isCommit = false;

  if (!isLogin.value) {
    G_goLogin();
    // mb_err('亲，请先登录哦', 2);
    return;
  }
  if (isCommit) {
    mb_toast(mb_t('操作过于频繁'), 2);
    return;
  }
  if (isFreeUser.value) {
    mb_toast(mb_t('试玩账号不能进入该游戏、请注册正式会员'), 2);
    router.replace('/');
    return;
  }
  if (!item) {
    showFailToast(mb_t('彩种信息缺失'));
    return;
  }
  let playstate = gameStore.playAllStates[item.play_id];
  if (playstate && playstate.play) {
    if (playstate.play.play_state === 2) {
      showFailToast(mb_t('暂停销售'));
      return;
    } else if (playstate.play.play_state === 3) {
      showFailToast(mb_t('停止销售'));
      return;
    }
  }
  const limited = await gameStore.checking3GameLimited({ play_id: item.play_id });
  const blance = sportsStore.blance / 1000;
  // @ts-ignore
  if (blance < limited?.deposit_min_money) {
    // @ts-ignore
    showFailToast(mb_t('余额低于{num}，暂时无法游戏', { num: limited?.deposit_min_money }));
    return false;
  }
  isCommit = true;
  item.gameId = item.play_id;
  showLoadingToast({
    message: mb_t('努力加载中'),
    forbidClick: true,
    duration: 0,
    loadingType: 'spinner',
  });
  gameStore
    .checking3Game({
      play_id: item.play_id,
    })
    .then((res: any) => {
      isCommit = false;
      if (res.response_code && res.response_code === '9999') {
        const payload: any = {
          play_id: item.play_id,
          data: { type: item.play_name },
          params: item,
        };
        if (Number(item.play_id) === 412) {
          payload.data = { type: 'SMG_titaniumLiveGames_MP_Baccarat' };
        } else if (Number(item.play_id) === 1313) {
          // PRETTY真人
          payload.data = { type: '1' };
        } else if (Number(item.play_id) === 1034) {
          payload.data = { type: '80' };
        }
        gameStore
          .get3GameUrl(payload)
          .then((res: any) => {
            closeToast();
            if (res && res.url) {
              const _urlInfo = transferThirdGameUrl(res.url, payload, item);
              goLinkGame(_urlInfo);
            } else {
              showFailToast(mb_t('未获取到三方平台地址'));
            }
          })
          .catch(err => {
            closeToast();
            mb_err(err.toString());
          });
      } else {
        closeToast();
      }
    })
    .catch(err => {
      closeToast();
      isCommit = false;
      if (err) {
        if (err.exMessage) {
          mb_err(err.exMessage.toString());
        } else if (err.info) {
          mb_err(err.info.toString());
        }
      }
    });
};

// 捕鱼 跳转第三方游戏
export const goBYThirdPlatform = item => {
  const gameStore = useGameStore();
  const { hotData } = useHot();
  const { isLogin, isFreeUser } = hotData;
  let isCommit = false;

  if (!isLogin.value) {
    G_goLogin();
    // mb_err('亲，请先登录哦', 2);
    return;
  }
  // 1 正常销售2 暂停销售3 停止销售4 内部测试5 归档，前端只处理1、2、4
  if (item.state === 2) {
    showFailToast(mb_t('该游戏暂停销售'));
    return;
  }
  if (item.state === 4) {
    showFailToast(mb_t('该游戏为内部测试'));
    return;
  }
  if (isCommit) {
    showFailToast(mb_t('操作过于频繁'));
    return;
  }
  if (isFreeUser.value) {
    showFailToast(mb_t('试玩账号不能进入该游戏、请注册正式会员'));
    router.replace('/');
    return;
  }
  if (!item) {
    showFailToast(mb_t('彩种信息缺失'));
    return;
  }
  let playstate = gameStore.playAllStates[item.play_id];
  if (playstate && playstate.play) {
    if (playstate.play.play_state === 2) {
      showFailToast(mb_t('暂停销售'));
      return;
    } else if (playstate.play.play_state === 3) {
      showFailToast(mb_t('停止销售'));
      return;
    }
  }
  isCommit = true;
  item.gameId = item.play_id;
  showLoadingToast({
    message: mb_t('努力加载中'),
    forbidClick: true,
    duration: 0,
    loadingType: 'spinner',
  });
  gameStore
    .checking3Game({
      play_id: item.play_id,
    })
    .then((res: any) => {
      isCommit = false;
      if (res.response_code && res.response_code === '9999') {
        let payload: any = {};
        // 将有差异的拿出来判断，其他不需要
        payload.play_id = item.main_id || item.upper_id; // PLAY_ID=大类
        payload.type = item.play_name; // type 子类游戏ID
        // MG捕鱼, 天游捕鱼, CQ9捕鱼, 百胜捕鱼
        if ([396, 399, 408, 407].includes(item.upper_id)) {
          payload.data = { type: item.play_name };
        } else if ([397].includes(item.upper_id)) {
          // JDBBY
          payload.data = {
            gtype: 7,
            type: item.play_name,
          };
        } else if ([708].includes(item.upper_id)) {
          // FGBY
          payload.data = { type: helperFGBY.getGameId(item.play_id) };
        } else if ([1388].includes(item.upper_id)) {
          payload.data = { type: '200' };
          // 瓦力捕鱼
        } else if ([1032].includes(item.upper_id)) {
          payload.type = 1;
        }
        payload.buyu_game_id = item.play_id;
        payload.params = item;

        console.log('buyusubmit', payload, item);
        gameStore
          .get3GameUrl(payload)
          .then((res: any) => {
            closeToast();
            if (res && res.url) {
              const _urlInfo = transferThirdGameUrl(res.url, payload, item);
              goLinkGame(_urlInfo);
            } else {
              showFailToast(mb_t('未获取到三方平台地址'));
            }
          })
          .catch(err => {
            closeToast();
            if (err && err.info) {
              mb_err(err.info.toString());
            }
          });
      }
    })
    .catch(err => {
      closeToast();
      isCommit = false;
      if (err) {
        if (err.exMessage) {
          mb_err(err.exMessage.toString());
        } else if (err.info) {
          mb_err(err.info.toString());
        }
      }
    });
};

// 电子 跳转第三方游戏
export const goDZThirdPlatform = item => {
  const gameStore = useGameStore();
  const { hotData } = useHot();
  const { isLogin, isFreeUser } = hotData;
  let isCommit = false;
  if (!isLogin.value) {
    G_goLogin();
    // mb_err('亲，请先登录哦', 2);
    return;
  }
  if (isFreeUser.value) {
    showFailToast(mb_t('试玩账号不能进入该游戏、请注册正式会员'));
    router.replace('/');
    return;
  }
  // 1 正常销售2 暂停销售3 停止销售4 内部测试5 归档，前端只处理1、2、4
  if (item.gameState && +item.gameState === 2) {
    showFailToast(mb_t('该游戏暂停销售'));
    return;
  }
  if (item.state === 4) {
    showFailToast(mb_t('该游戏为内部测试'));
    return;
  }
  if (isCommit) {
    showFailToast(mb_t('操作过于频繁'));
    return;
  }
  isCommit = true;
  showLoadingToast({
    message: mb_t('努力加载中'),
    forbidClick: true,
    duration: 0,
    loadingType: 'spinner',
  });
  gameStore
    .checking3Game({
      play_id: item.play_id || item.playId,
    })
    .then((res: any) => {
      isCommit = false;
      if (res.response_code && res.response_code === '9999') {
        jumpDZ3Game(item);
      } else {
        closeToast();
      }
    })
    .catch(err => {
      closeToast();
      isCommit = false;
      if (err) {
        if (err.exMessage) {
          mb_err(err.exMessage.toString());
        } else if (err.info) {
          mb_err(err.info.toString());
        }
      }
    });
};

// 棋牌 跳转第三方游戏
export const goQPThirdPlatform = item => {
  const gameStore = useGameStore();
  const { hotData, tResLoc } = useHot();
  const { isLogin, isFreeUser, userInfo } = hotData;
  if (item.gameState && +item.gameState === 3) {
    showFailToast(mb_t('该游戏已暂停销售，请移至其它游戏'));
    return;
  }
  // 黑色主题 im体育 进入滚球页面
  if (tResLoc.value === 'black' && Number(item.play_id) === 931) {
    if (userInfo.value.fict_flag !== 1) {
      router.push('/game?key=gunqiu');
    } else {
      showToast(mb_t('用户权限不足'));
    }
    return;
  }
  if (item.isLotteryTicket) {
    if (!isLogin.value) {
      G_goLogin();
      // mb_err('亲，请先登录哦', 2);
      return;
    }
    goLotteryPlatform(item);
  } else {
    // if (GameBigTypesEnum.CHESS === item.big_type) {
    //   if (GameBigTypesEnum.CHESS === item.big_type) {
    //     if ((item.playId + '').length === 3) {
    //       let qiPaiPlay = [];
    //       if (gameStore.qiPaiPlayGames.length) {
    //         gameStore.qiPaiPlayGames.forEach(item => {
    //           if (+item.state !== 3) {
    //             qiPaiPlay.push(item);
    //           }
    //         });
    //       }
    //       const qiPaiPlayNew = qiPaiPlay
    //         ? qiPaiPlay
    //         : getQiPaiPlay(JSON.parse(window.localStorage.getItem('QiPaiPlayGames')));
    //       if (qiPaiPlayNew.some(ite => +ite.play_id === item.play_id)) {
    //         qiPaiPlayNew.forEach((item, index) => {
    //           if (+item.play_id === item.play_id) {
    //             gameStore.setSelectedType(index + 1);
    //           }
    //         });
    //       } else {
    //         showFailToast(mb_t('游戏未开启,尽请期待'));
    //       }
    //     } else {
    //       let index = gameStore.gameTabsData.findIndex(value => value.playId === item.playId);
    //       gameStore.setSelectedType(index);
    //     }
    //   }
    // } else {
    if (!isLogin.value) {
      G_goLogin();
      // mb_err('亲，请先登录哦', 2);
      return;
    }
    if (isFreeUser.value) {
      showFailToast(mb_t('试玩账号不能进入该游戏、请注册正式会员'));
      router.replace('/');
      return;
    }
    let data: any = { type: item.gameKey };
    if (Number(item.gameId) === 340 || Number(item.gameId) === 397) {
      data.gtype = item.gtype;
    }
    if (Number(item.gameId) === 1326) {
      data.type = 1;
    }
    showLoadingToast({
      message: mb_t('努力加载中'),
      forbidClick: true,
      duration: 0,
      loadingType: 'spinner',
    });
    gameStore
      .checking3Game({
        play_id: item.play_id || item.playId,
      })
      .then((res: any) => {
        if (res.response_code && res.response_code === '9999') {
          const payload: any = {
            data,
            play_id: item.gameId,
          };
          if (payload.play_id === 1313) {
            // PRETTY真人
            payload.data.type = '1';
          }
          payload.params = item;
          gameStore
            .get3GameUrl(payload)
            .then((res: any) => {
              closeToast();
              const _urlInfo = transferThirdGameUrl(res.url, payload, item);
              if (res && res.url) {
                goLinkGame(_urlInfo);
              } else {
                showFailToast(mb_t('未获取到三方平台地址'));
              }
            })
            .catch(err => {
              closeToast();
              showFailToast(err.toString());
            });
        } else {
          closeToast();
        }
      })
      .catch(err => {
        closeToast();
        if (err) {
          if (err.exMessage) {
            mb_err(err.exMessage.toString());
          } else if (err.info) {
            mb_err(err.info.toString());
          }
        }
      });
    // }
  }
};

// 棋牌 试玩跳转第三方游戏
export const goTryQPThirdPlatform = async item => {
  const gameStore = useGameStore();
  const { hotData, tResLoc } = useHot();
  const { isLogin, isFreeUser, userInfo } = hotData;
  if (!item.gameId) {
    item.gameId = item.play_id;
  }
  if (item.gameState && +item.gameState === 3) {
    showFailToast(mb_t('该游戏已暂停销售，请移至其它游戏'));
    return;
  }
  // 黑色主题 im体育 进入滚球页面
  if (tResLoc.value === 'black' && Number(item.play_id) === 931) {
    if (userInfo.value.fict_flag !== 1) {
      router.push('/game?key=gunqiu');
    } else {
      showToast(mb_t('用户权限不足'));
    }
    return;
  }
  if (item.isLotteryTicket) {
    if (!isLogin.value) {
      G_goLogin();
      // mb_err('亲，请先登录哦', 2);
      return;
    }
    goLotteryPlatform(item);
  } else {
    let data: any = { type: item.gameKey };
    if (Number(item.gameId) === 340 || Number(item.gameId) === 397) {
      data.gtype = item.gtype;
    }
    if (Number(item.gameId) === 1326) {
      data.type = 1;
    }
    showLoadingToast({
      message: mb_t('努力加载中'),
      forbidClick: true,
      duration: 0,
      loadingType: 'spinner',
    });

    try {
      // 调用 `checking3Game` 检查游戏状态
      const res = await gameStore.checking3Game({
        play_id: item.play_id || item.playId,
      });

      if (res.response_code !== '9999') return closeToast();

      const payload = {
        data,
        play_id: item.gameId,
      };

      // 特殊处理 PRETTY真人游戏
      if (payload.play_id === 1313) {
        payload.data.type = '1';
      }

      // 获取试玩地址
      const specialGame = {
        297: 'https://yl.kocms397.com/', // 开元棋牌
        401: 'https://nw.kocms397.com/', // 新世界棋牌
        707: 'https://fungaming.com/#/game', // FG电子
      };
      let gameRes: any;
      if (specialGame[payload.play_id]) {
        gameRes = {
          url: specialGame[payload.play_id],
        };
      } else {
        gameRes = await gameStore.getTry3GameUrl(payload);
      }

      closeToast();
      if (gameRes?.url) {
        const _urlInfo = transferThirdGameUrl(gameRes.url, payload, item);
        goLinkGame(_urlInfo);
        console.log('游戏信息', _urlInfo);
      } else {
        showFailToast(mb_t('未获取到三方平台地址'));
      }
    } catch (err: any) {
      closeToast();
      const errorMessage = err?.exMessage || err?.info || err.toString();
      if (errorMessage) {
        mb_err(errorMessage);
      }
    }
  }
};

export const goLotteryPlatform = obj => {
  let value = ConfigUtils.deepCopy(obj);
  const { hotData } = useHot();
  const { userInfo, isLogin } = hotData;
  if (!isLogin.value) {
    G_goLogin();
    // mb_err('亲，请先登录哦', 2);
    return;
  }
  const play = ConfigUtils.getPlayInfo(value.play_id);
  if (!value.sub_play_id && play) {
    value.sub_play_id = play.default;
    if (value.play_cat === 4 && play._default) {
      value.sub_play_id = play._default;
    }
  }
  if (userInfo.value.fict_flag) {
    if (value.type === 3 || value.type === 4 || value.type === 5 || value.type === 8) {
      const url = '/game/pk10?playid=' + value.play_id + '&goback=0&subplayid=' + value.sub_play_id;
      router.push(url);
    } else if (value.type === 6) {
      let url;
      if (value.play_id === 33) {
        url = '/game/hklottery?playid=' + value.play_id + '&goback=0&subplayid=' + value.sub_play_id;
        router.push(url);
      } else if (value.play_id === 42) {
        url = '/game/cqlhc?playid=' + value.play_id + '&goback=0&subplayid=' + value.sub_play_id;
        router.push(url);
      }
    } else if (value.type === 7) {
      const url = '/game/k3?playid=' + value.play_id + '&goback=0&subplayid=' + value.sub_play_id;
      router.push(url);
    } else if (value.type === 2) {
      const url = '/game/roomchat?playid=' + value.play_id;
      playChatGame(value.play_id, url);
    } else if (value.type === 0) {
      let play = ConfigUtils.getPlayInfo(value.play_id) || {};
      if (play.cat === 'QKL') {
        router.push('/game/qkl?playid=' + value.play_id);
      } else {
        router.push('/game/ydc?playid=' + value.play_id);
      }
    } else if (value.type === 19) {
      const url = '/game/fc3d?playid=' + value.play_id + '&goback=0&subplayid=' + value.sub_play_id;
      router.push(url);
    } else if (value.type === 20) {
      router.push('/game/xnb?playid=' + value.play_id);
    } else if (value.type === 21) {
      router.push('/game/qkl?playid=' + value.play_id);
    }
  } else {
    if (value.type === 3 || value.type === 4 || value.type === 5 || value.type === 8) {
      const url = '/game/pk10?playid=' + value.play_id + '&goback=0&subplayid=' + value.sub_play_id;
      router.push(url);
    } else if (value.type === 6) {
      let url;
      if (value.play_id !== 42) {
        url = '/game/hklottery?playid=' + value.play_id + '&goback=0&subplayid=' + value.sub_play_id;
        router.push(url);
      } else if (value.play_id === 42) {
        url = '/game/cqlhc?playid=' + value.play_id + '&goback=0&subplayid=' + value.sub_play_id;
        router.push(url);
      }
    } else if (value.type === 7) {
      if (value.play_cat === 4) {
        const url = '/game/pk10?playid=' + value.play_id + '&goback=0&subplayid=' + value.sub_play_id;
        router.push(url);
      } else {
        const url = '/game/k3?playid=' + value.play_id + '&goback=0&subplayid=' + value.sub_play_id;
        router.push(url);
      }
    } else if (value.type === 2) {
      const url = '/game/roomchat?playid=' + value.play_id;
      playChatGame(value.play_id, url);
    } else if (value.type === 0) {
      let play = ConfigUtils.getPlayInfo(value.play_id) || {};
      if (play.cat === 'QKL') {
        router.push('/game/qkl?playid=' + value.play_id);
      } else {
        router.push('/game/ydc?playid=' + value.play_id);
      }
    } else if (value.type === 19) {
      const url = '/game/fc3d?playid=' + value.play_id + '&goback=0&subplayid=' + value.sub_play_id;
      router.push(url);
    } else if (value.type === 20) {
      router.push('/game/xnb?playid=' + value.play_id);
    } else if (value.type === 21) {
      router.push('/game/qkl?playid=' + value.play_id);
    }
  }
};

export const goTianChengPlatform = info => {
  const gameStore = useGameStore();
  const { hotData } = useHot();
  const { isLogin, isFreeUser } = hotData;
  if (!isLogin.value) {
    G_goLogin();
    return;
  }
  if (isFreeUser.value) {
    showConfirmDialog({
      title: mb_t('提示'),
      message: mb_t('试玩账号不能进入该游戏、请注册正式会员'),
      confirmButtonText: mb_t('去注册'),
      cancelButtonText: mb_t('下次吧'),
    })
      .then(() => {
        router.replace('/');
      })
      .catch(() => {
        router.back();
      });
    return;
  }
  showLoadingToast({
    message: mb_t('努力加载中'),
    forbidClick: true,
    duration: 0,
    loadingType: 'spinner',
  });
  gameStore
    .checking3Game({
      play_id: info.playId || info.play_id,
    })
    .then((res: any) => {
      if (res.response_code && res.response_code === '9999') {
        jump3Game(info);
      } else {
        closeToast();
      }
    })
    .catch(err => {
      closeToast();
      if (err.exMessage) {
        mb_err(err.exMessage.toString());
      } else if (err.info) {
        mb_err(err.info.toString());
      }
    });
};

export const goBlockGame = item => {
  const { hotData } = useHot();
  const { isLogin } = hotData;
  if (!isLogin.value) {
    G_goLogin();
    // mb_err('亲，请先登录哦', 2);
    return;
  }
  // Crash 直接跳
  if (item.name === 'crash') {
    router.push('/crash');
    return;
  }
  if (item.name === 'mine') {
    router.push('/mines');
    return;
  }
  if (item.name === 'dabble') {
    router.push('/double');
    return;
  }
  if (item.name === 'dice') {
    router.push('/dice');
    return;
  }
};

// 根据cat_id判断大游戏分类数据
export const getGameInfo = (item: Record<string, any>) => {
  let gameInfo: any = null;
  switch (Number(item.big_type ?? item.play_big_type)) {
    case 1:
      gameInfo = {
        type: 'qipai',
        fav_type: 17,
        gameType: GameMainTypesEnum.CHESS,
      };
      break;
    case 2:
      gameInfo = {
        type: 'dianzi',
        fav_type: 12,
        gameType: GameMainTypesEnum.ELECTRONIC,
      };
      break;
    case 5:
      gameInfo = {
        type: 'tiyu',
        fav_type: 15,
        gameType: GameMainTypesEnum.SPORTS,
      };
      break;
    case 4:
      gameInfo = {
        type: 'zhenren',
        fav_type: 11,
        gameType: GameMainTypesEnum.LIVE,
      };
      break;
    // case 7:
    //   gameInfo = {
    //     type: 'hongbao',
    //     fav_type: 14
    //   };
    //   break;
    default:
      // 捕鱼
      if (item.main_id) {
        gameInfo = {
          type: 'buyu',
          fav_type: 13,
          gameType: GameMainTypesEnum.FISHING,
        };
      } else if (item.upper_play_id) {
        gameInfo = {
          type: 'dianzi',
          fav_type: 12,
          gameType: GameMainTypesEnum.ELECTRONIC,
        };
      } else {
        gameInfo = {
          type: 'caipiao',
          fav_type: 16,
          gameType: GameMainTypesEnum.LOTTERY,
        };
      }
  }
  return gameInfo;
};

// 返回热门游戏封装后的数据
export const getHotGamesData = hotGames => {
  let arr: any[] = [];
  let imgUrl = '';
  let iconPath = '';
  console.log('hotGameshotGames', hotGames);
  for (let i = 0; i < hotGames.length; i++) {
    const item = hotGames[i];
    let lotteryTicket = false;
    let isPlatform = false;
    const localPathMap = {
      [GameBigTypesEnum.LOTTERY]: GameMainKeysEnum.LOTTERY,
      [GameBigTypesEnum.FISHING]: GameMainKeysEnum.FISHING,
      [GameBigTypesEnum.ELECTRONIC]: GameMainKeysEnum.ELECTRONIC,
      [GameBigTypesEnum.CHESS]: GameMainKeysEnum.CHESS,
      [GameBigTypesEnum.BLOCK_THIRD]: GameMainKeysEnum.BLOCK_THIRD,
      [GameBigTypesEnum.LIVE]: GameMainKeysEnum.LIVE,
      [GameBigTypesEnum.SPORTS]: GameMainKeysEnum.SPORTS,
    };
    iconPath = getHotGameImgSrc(localPathMap[item.big_type], item, 'color');
    if (item.play_id === item.upper_play_id) {
      imgUrl =
        handleServerGameImg(item.logo1_img_url) ||
        `/images/game/${localPathMap[item.big_type]}/h_${item.upper_play_id}.png`; // /images/game/sports/m_1031.png
      isPlatform = true;
    } else {
      imgUrl = getServerImg(item);
    }
    // 哈希游戏
    // if (item.play) {
    //   item.type = 'hash';
    //   item.play_name = item.play.name;
    //   item.play_cname = item.play.showname;
    //   item.play_id = item.id;
    //   item.isOriginal = !item.addressIn;
    //   imgUrl = '';
    // }
    // // 原创
    // if (item.showName) {
    //   item.type = 'hash';
    //   item.play_name = item.name;
    //   item.play_cname = item.showName;
    //   item.play_id = item.id;
    //   item.isOriginal = true;
    //   imgUrl = '';
    // }
    if (!arr.some(ele => ele.play_id == item.play_id)) {
      arr.push({
        ...item,
        playId: item.play_id,
        gameId: item.upper_play_id,
        gameImgUrl: imgUrl,
        gameKey: item.play_name,
        gameName: item.play_cname,
        isLotteryTicket: lotteryTicket,
        iconPath,
        isPlatform,
      });
    }
  }
  // 接口排序
  return arr;
};

// 返回试玩游戏封装后的数据
export const getTryGamesData = hotGames => {
  let arr: any[] = [];
  let lang = $t2en(i18n.global.locale);
  let str = 'qipai';
  let imgUrl = '';
  let iconPath = '';
  const tenantState = useTenantStore();
  const { imgDomain } = storeToRefs(tenantState);
  for (let i = 0; i < hotGames.length; i++) {
    const item = hotGames[i];
    let lotteryTicket = false;
    if (GameBigTypesEnum.LOTTERY === item.big_type) {
      let play = ConfigUtils.getPlayInfo(item.play_id);
      if (play) {
        imgUrl =
          imgDomain.value +
          'staticQ/caipiao/default/' +
          lang +
          '/icon_play_' +
          (play.icon !== undefined ? (item.play_cat === 4 && play.base ? play.base + '_XY' : play.icon) : play.id) +
          '.png';
      }
      lotteryTicket = true;
    } else if (GameBigTypesEnum.FISHING === item.big_type) {
      imgUrl = `${imgDomain.value}staticQ/buyu/${item.upper_play_id}/${lang}/${'game_' + item.play_id}.png`;
      iconPath = getHotGameImgSrc(GameMainKeysEnum.FISHING, item.upper_play_id, 'color');
    } else if (GameBigTypesEnum.ELECTRONIC === item.big_type) {
      imgUrl = `${imgDomain.value}staticQ/dianzi/${item.upper_play_id}/${lang}/${'game_' + (item.upper_play_id === 340 ? item.play_name : item.play_id)}.png`;
      iconPath = getHotGameImgSrc(GameMainKeysEnum.ELECTRONIC, item.upper_play_id, 'color');
    } else if (GameBigTypesEnum.CHESS === item.big_type) {
      imgUrl = `${imgDomain.value}staticQ/qipai/${item.upper_play_id}/${lang}/${'game_' + (item.upper_play_id === 340 ? item.play_name : item.play_id)}.png`;
      iconPath = getHotGameImgSrc(GameMainKeysEnum.CHESS, item.upper_play_id, 'color');
    }
    if (GameBigTypesEnum.LIVE === item.big_type) {
      imgUrl = `/images/game/live/g_${item.play_id}.png`;
    }
    // 哈希游戏
    if (item.play) {
      item.type = 'hash';
      item.play_name = item.play.name;
      item.play_cname = item.play.showname;
      item.play_id = item.id;
      item.isOriginal = !item.addressIn;
      imgUrl = '';
    }
    // 原创
    if (item.showName) {
      item.type = 'hash';
      item.play_name = item.name;
      item.play_cname = item.showName;
      item.play_id = item.id;
      item.isOriginal = true;
      imgUrl = '';
    }
    // if (!arr.some(ele => ele.play_id == item.play_id)) {
    arr.push({
      ...item,
      playId: item.play_id,
      gameId: item.upper_play_id,
      gameImgUrl: imgUrl,
      gameKey: item.play_name,
      gameName: item.play_cname,
      isLotteryTicket: lotteryTicket,
      iconPath,
    });
    // }
  }

  return arr;
};

export const goThirdPlatform = (item, type, isTry?) => {
  const _backGameTime = Number(window.sessionStorage.getItem('IN_THIRD_GAME_TIME'));
  const _current = new Date().valueOf();
  if (_current - _backGameTime < 3000) {
    showToast(mb_t('点击过于频繁'));
    return false;
  }
  if (type === 'chess') {
    isTry ? goTryQPThirdPlatform(item) : goQPThirdPlatform(item);
  } else if (type === 'electronic' || type === 'blockThird') {
    goDZThirdPlatform(item);
  } else if (type === 'fishing') {
    goBYThirdPlatform(item);
  } else if (type === 'sports') {
    goTYThirdPlatform(item);
  } else if (type === 'live') {
    goZRThirdPlatform(item);
  }
};

const replace = val => {
  return val.replace('已停盘，开盘时间为', mb_t('已停盘，开盘时间为'));
};

// 检测彩票玩法状态，进入对应路由
export const testCanPlay = value => {
  // 跳相应的子彩种界面
  const gameStore = useGameStore();
  const { hotData } = useHot();
  const { userInfo } = hotData;
  showLoadingToast({
    message: mb_t('努力加载中'),
    forbidClick: true,
    duration: 0,
    loadingType: 'spinner',
  });
  gameStore
    .testCanPlay({
      main_play_id: value.play_id || value.id,
    })
    .then(() => {
      closeToast();
      if (value.state !== 1 && value.state !== 4) {
        switch (value.state) {
          case 2:
            showToast(mb_t('该彩种暂停销售'));
            break;
          case 5:
            showToast(mb_t('该彩种不在销售时间'));
            break;
          case 9:
            showToast(mb_t('该彩种已归档'));
            break;
        }
      } else if (value.state === 1) {
        let url = `/${value.page}?playid=${value.id}&goback=0&subplayid=${value.default}`;
        router.push(url);
      } else if (value.tate === 4 && userInfo.value.fict_flag) {
        const url = `/${value.page}?playid=${value.id}&goback=0&subplayid=${value.default}`;
        router.push(url);
      } else if (value.state === 4 && !userInfo.value.fict_flag) {
        showToast(mb_t('当前彩种正处于内测阶段，敬请期待'));
      }
    })
    .catch(err => {
      closeToast();
      if (err?.info) {
        mb_err(replace(err.info));
      }
    });
};

// 电子的数据组装
export const dealDZList = (data: any[]) => {
  let arr: any[] = [];
  const _length = data && data.length > 0 ? data.length : 0;
  for (let i = 0; i < _length; i++) {
    let subGamesItem = data[i];
    let gameImgUrl = getServerImg(subGamesItem);
    if (subGamesItem.state !== 3) {
      arr.push({
        ...subGamesItem,
        playId: subGamesItem.play_id,
        gtype: subGamesItem.gtype,
        gameId: subGamesItem.upper_id || subGamesItem.upper_play_id,
        gameKey: subGamesItem.play_name,
        gameName: subGamesItem.play_cname,
        gameImgUrl: handleServerGameImg(subGamesItem.thumbnail_img_url) || gameImgUrl,
        gameState: subGamesItem.state,
      });
    }
  }
  return arr;
};

// 棋牌的数据组装
export const dealQPList = data => {
  let arr: any[] = [];
  const tenantState = useTenantStore();
  const { imgDomain } = storeToRefs(tenantState);
  let lang = i18n.global.locale.value === 'zh' ? 'cn' : i18n.global.locale.value;
  let str = 'qipai';
  let imgUrl = '';
  if (data) {
    for (let i = 0; i < data.length; i++) {
      let subGamesItem = data[i];
      let mainId = subGamesItem.upper_id || subGamesItem.upper_play_id;
      if (subGamesItem.state !== 3 && !arr.some(ele => ele.playId === subGamesItem.play_id)) {
        imgUrl = `${imgDomain.value}staticQ/qipai/${mainId}/${lang}/${'game_' + subGamesItem.play_id}.png`;
        if (mainId === 506 && subGamesItem.play_id !== 506) {
          imgUrl = `${imgDomain.value}staticQ/${subGamesItem.terrace_id === 504 ? 'caipiao' : 'qipai'}/${mainId}/${lang}/game_${subGamesItem.play_id}.png`;
        }
        arr.push({
          ...subGamesItem,
          playId: subGamesItem.play_id,
          gameId: mainId,
          gameKey: subGamesItem.play_name,
          gameName: subGamesItem.play_cname,
          gameImgUrl: handleServerGameImg(subGamesItem.thumbnail_img_url) || imgUrl,
          gameState: subGamesItem.state,
          play_cat: subGamesItem.play_cat,
        });
      }
    }
  }
  return arr;
};

// 棋牌的数据组装
export const dealBYList = data => {
  let arr: any[] = [];
  const tenantState = useTenantStore();
  const { imgDomain } = storeToRefs(tenantState);
  let lang = i18n.global.locale.value === 'zh' ? 'cn' : i18n.global.locale.value;
  let str = 'buyu';
  let imgUrl = '';
  if (data) {
    for (let i = 0; i < data.length; i++) {
      let subGamesItem = data[i];
      if (!subGamesItem.upper_id) {
        subGamesItem.upper_id = subGamesItem.upper_play_id;
      }

      if (subGamesItem.state !== 3 && !arr.some(ele => ele.playId === subGamesItem.play_id)) {
        imgUrl = `${imgDomain.value}staticQ/${str}/${subGamesItem.upper_id}/${lang}/${'game_' + subGamesItem.play_id}.png`;
        arr.push({
          ...subGamesItem,
          playId: subGamesItem.play_id,
          play_id: subGamesItem.play_id,
          gameId: subGamesItem.upper_id,
          main_id: subGamesItem.upper_id,
          gameKey: subGamesItem.play_name,
          play_name: subGamesItem.play_name,
          gameName: subGamesItem.play_cname,
          gameImgUrl: handleServerGameImg(subGamesItem.thumbnail_img_url) || imgUrl,
          gameState: subGamesItem.state,
          play_cat: subGamesItem.play_cat,
          gameType: 'BY',
        });
      }
    }
  }
  return arr;
};

// 棋牌、电子,捕鱼 图片路径
export const getServerImg = item => {
  let lang = ['cn', 'zh'].includes(i18n.global.locale.value) ? 'cn' : 'en';
  let imgUrl = '';
  item.upper_play_id = item.upper_play_id || item.upper_id || item.play_id;
  const tenantState = useTenantStore();
  const { imgDomain } = storeToRefs(tenantState);
  // 真人,体育这种读取本地或者后台配置
  const pathKey = serverImgPathMap[item.big_type];
  if (pathKey) {
    let picName = 'game_' + item.play_id;
    if (Number(item.upper_play_id) === 340) {
      picName = 'game_' + item.play_name;
    }
    imgUrl = `${imgDomain.value}staticQ/${pathKey}/${item.upper_play_id}/${lang}/${picName}.png`;
  }
  return handleServerGameImg(item.thumbnail_img_url) || imgUrl;
};

const jumpDZ3Game = info => {
  console.log(info, '111111111111111');
  const gameStore = useGameStore();
  let data: any = {};
  data.type = info.gameKey;
  if (String(info.gameId).substr(0, 3) === '340') {
    info.gameId = 340;
    data.gtype = info.gtype;
  }
  info.play_id = info.playId;
  if (info.play_id === 1313) {
    // PRETTY真人
    data.type = '1';
  }
  // let newTab = null;
  // if (isTenant14_1()) {
  //   newTab = window.open('about:blank');
  // }
  const payload = {
    data,
    play_id: info.gameId,
    params: info,
  };
  gameStore.get3GameUrl(payload).then((res: any) => {
    closeToast();
    if (res && res.url) {
      const _urlInfo = transferThirdGameUrl(res.url, payload, info);
      // if (isTenant14_1()) {
      //   newTab.location.href = res.url;
      //   return;
      // }
      const gameName = info.play_cname || info.gameName;
      window.sessionStorage.setItem('CURRENT_GAME_NAME', gameName);
      goLinkGame(_urlInfo);
      // showConfirmDialog({
      //   message: mb_t('enter_xxx_game', { gameName }),
      //   showConfirmButton: true,
      //   showCancelButton: true,
      //   className: 'enter3gameDialog',
      //   overlayClass: 'enter3gameDialogoverlay',
      //   teleport: 'body',
      //   closeOnPopstate: true,
      //   closeOnClickOverlay: false,
      //   confirmButtonText: mb_t('确定'),
      //   cancelButtonText: mb_t('取消'),
      // })
      //   .then(() => {
      //     window.sessionStorage.setItem('CURRENT_GAME_NAME', gameName);
      //     goLinkGame(_urlInfo);
      //   })
      //   .catch(() => {
      //     close3Game(payload.play_id);
      //   });
    } else {
      mb_err('未获取到三方平台地址');
    }
  });
  // .catch(err => {
  //   closeToast();
  //   mb_err(err?.info);
  // });
};

const goLinkGame = (info: any) => {
  if (info.target === '_self') {
    router.push({ path: '/game/iframe', query: { from: location.pathname } });
    // setTimeout(() => {
    //   location.reload();
    // }, 300);
  } else {
    openWebsite(info.url);
  }
};

const jump3Game = info => {
  const gameStore = useGameStore();
  let data = {} as any;
  if (info.playId === 504) {
    data.isMobileOpen = 1;
    data.type = info.play_name;
  }
  if ((info.playId || info.play_id) === 1326) {
    data.type = 1;
  } else {
    data.type = info.code || info.play_name;
  }
  info.gameId = info.upperId;
  const payload = {
    data: data,
    play_id: info.upperId || info.play_id,
    params: info,
  };
  if (payload.play_id === 1313) {
    // PRETTY真人
    payload.data.type = '1';
  }
  // let newTab = null;
  // if (isTenant14_1()) {
  //   newTab = window.open('about:blank');
  // }
  gameStore.get3GameUrl(payload).then((res: any) => {
    closeToast();
    if (res && res.url) {
      const _urlInfo = transferThirdGameUrl(res.url, payload, info);
      goLinkGame(_urlInfo);
      info._params = { data, play_id: info.upperId };
    }
  });
  // .catch(err => {
  //   closeToast();
  //   if (err.exMessage) {
  //     mb_err(err.exMessage.toString());
  //   } else if (err.info) {
  //     mb_err(err.info.toString());
  //   }
  // });
};

const playChatGame = (playid, url) => {
  const gameStore = useGameStore();
  let play = ConfigUtils.getPlayInfo(playid);
  gameStore
    .reqChatByNames({
      play_names: play.play_name,
    })
    .then(res => {
      if (res) {
        let roomType = null;
        for (let key in res) {
          let itemType = res[key];
          if (!roomType) {
            roomType = itemType;
          }
          if (Number(itemType.room_type_id) === Number(gameStore.roomTypeId)) {
            roomType = itemType;
            break;
          }
        }
        // 设置房间类型
        if (roomType) {
          if (roomType.playRooms) {
            let room = null;
            for (let i = 0; i < roomType.playRooms.length; i++) {
              let roomItem = roomType.playRooms[i];
              if (!room) {
                room = roomItem;
              }
              if (Number(roomItem.play_room_id) === Number(gameStore.roomId)) {
                room = roomItem;
                break;
              }
            }
            if (room) {
              gameStore.setCurRoomType(roomType);
              gameStore.setCurRoom(room);
              router.push(url);
            }
          }
        }
      }
    })
    .catch(err => {
      mb_err(err.info);
    });
};

// 处理IM体育在不同代理盘下的名称显示
// 主盘取租户名字，tenant_name
// 代理盘1取  tenant_des
// 代理盘2取 xmpp
export const formatIMSport = name => {
  const { hotData } = useHot();
  const { tenantInfo } = hotData;
  const proxy = Number(tenantInfo.value.proxy);
  let reName = name;
  if (name === 'IM体育') {
    if (proxy === 0) {
      reName = tenantInfo.value.tenant.tenant_name;
    } else if (proxy === 1) {
      reName = tenantInfo.value.tenant.tenant_des;
    } else if (proxy === 2) {
      reName = tenantInfo.value.tenant.xmpp;
    }
  }
  return mb_t(reName);
};

export const haxi = [
  'HASH_ZHUANGXIAN',
  'HASH_LUCKNUMBER',
  'HASH_LUCKY',
  'HASH_NIUNIU5',
  'HASH_NORMALNIUNIU',
  'HASH_PK10',
];

export const originalGames = ['crash', 'mine', 'dabble', 'dice'];
const typeObj = {
  sx: {
    type: 11,
    text: '真人视讯',
    name: 'sx',
  }, // 真人视讯
  dz: {
    type: 12,
    text: '电子游艺',
    name: 'dz',
  }, // 电子游艺术
  by: {
    type: 13,
    text: '捕鱼大厅',
    name: 'by',
  }, // 捕鱼大厅
  hb: {
    type: 14,
    text: '红包游戏',
    name: 'hb',
  }, // 红包游戏
  ty: {
    type: 15,
    text: '体育大厅',
    name: 'ty',
  }, // 体育大厅
  cp: {
    type: 16,
    text: '彩票游戏',
    name: 'cp',
  }, // 彩票游戏
  qp: {
    type: 17,
    text: '棋牌大厅',
    name: 'qp',
  }, // 棋牌大厅
};

export const dealCollectData = list => {
  const tenantState = useTenantStore();
  const { imgDomain } = storeToRefs(tenantState);
  const { language } = storeToRefs(useAppStore());

  return list
    .filter(i => i.play_state !== 3 && i.play_state !== 9)
    .map(item => {
      let { type, msg } = item;
      let lang = language.value === 'zh' ? 'cn' : 'en';
      msg = msg ? JSON.parse(msg) : {};
      console.log(item, 'big_type');
      // 真人视讯
      if (msg?.big_type === 4) {
        msg.gameImgUrl = `/images/game/live/g_${msg.play_id}.png`;
      }
      // 体育
      if (msg?.big_type === 5) {
        msg.gameImgUrl = `/images/game/sports/g_${msg.play_id}.png`;
      }
      // 彩票
      if (msg?.big_type === 7) {
        msg.gameImgUrl = `/images/game/lottery/g_${msg.play_id}.png`;
      }
      if (msg.imgUrl) {
        msg.imgUrl = msg.imgUrl.replace('i18n_locale', lang);
      } else {
        if (msg.gameImgUrl) {
          msg.gameImgUrl = msg.gameImgUrl.replace(/\/cn\/|\/en\/|\/id\/|\/ms\/|\/pt\/|\/th\/|\/iv\//, `/${lang}/`);
        }
      }
      if (msg.main_id) {
        msg.main_id = Number((msg.main_id + '').substr(0, 4));
      }
      if (GameBigTypesEnum.ELECTRONIC === item.big_type) {
        let smallclass = msg.upper_play_id === 340 || msg.gameId === 340 ? msg.play_name : msg.play_id || msg.playId;
        msg.gameImgUrl = `${imgDomain.value}staticQ/dianzi/${msg.upper_play_id || msg.gameId || msg.play_id}/${lang}/game_${smallclass}.png`;
      }
      if (msg.upperId === 504 || msg.upper_play_id === 504 || msg.gameId === 504) {
        msg.gameImgUrl = `${imgDomain.value}staticQ/caipiao/${msg.upper_play_id || msg.gameId || msg.upperId}/${lang}/game_${msg.play_id || msg.playId}.png`;
      }
      let smallclass = msg.play_id || msg.playId;
      if (GameBigTypesEnum.CHESS === item.big_type) {
        msg.gameImgUrl = `${imgDomain.value}staticQ/qipai/${msg.upper_play_id || msg.gameId || msg.main_id}/${lang}/game_${smallclass}.png`;
      }
      if (GameBigTypesEnum.FISHING === item.big_type) {
        msg.gameImgUrl = `${imgDomain.value}staticQ/buyu/${msg.upper_play_id || msg.gameId || msg.main_id}/${lang}/game_${smallclass}.png`;
      }
      if (GameBigTypesEnum.FISHING === item.big_type) {
        let big_id = item.upper_play_id || msg.upper_id || msg.main_id || item.play_id;
        msg.gameImgUrl = `${imgDomain.value}staticQ/buyu/${big_id}/${lang}/${'game_' + item.play_id}.png`;
        item.gameImgUrl = msg.gameImgUrl;
      }
      if (haxi.includes(msg.play_name)) {
        msg.gameImgUrl = `/darkImages/home/${msg.play_name}.png`;
      }
      if (originalGames.includes(msg.play_name)) {
        msg.gameImgUrl = `/darkImages/home/game_${msg.play_name}.png`;
      }
      const _typeObj: any = Object.values(typeObj).filter(item => item.type === type)[0] || {};
      if (item.play_id === 1326) {
        item._isTiancheng = '1';
        item.type = 16;
      }
      if (item.play_id === 1385) {
        item._isTiancheng = '1';
        item.type = 37;
      }
      if (!item.gameImgUrl && !msg.gameImgUrl) {
        if (item.play_big_type === 5) {
          item.gameImgUrl = `/images/gameAll/ty/${item.play_id}.png`;
        }
        if (item.play_big_type === 2) {
          item.gameImgUrl = `/images/gameAll/dz/${item.playName}.png`;
        }
        if (item.play_big_type === 1) {
          item.gameImgUrl = `/images/gameAll/qp/${item.play_id}.png`;
        }
      }
      return {
        ...msg,
        from: _typeObj.text,
        ...item,
        play_collection: 2,
      };
    });
};

export const goThirdLotteryGame = item => {
  const gameStore = useGameStore();
  const { hotData, tResLoc } = useHot();
  const { isFreeUser, userInfo } = hotData;
  let isCommit = false;
  const { isLogin } = storeToRefs(useUserStore());

  if (!isLogin.value) {
    G_goLogin();
    return;
  }
  if (isCommit) {
    mb_err('操作过于频繁', 2);
    return;
  }
  if (isFreeUser.value) {
    mb_err('试玩账号不能进入该游戏、请注册正式会员', 2);
    router.replace('/');
    return;
  }
  if (!item) {
    mb_err('彩种信息缺失', 2);
    return;
  }

  isCommit = true;
  showLoadingToast({
    message: mb_t('努力加载中'),
    forbidClick: true,
    duration: 0,
    loadingType: 'spinner',
  });
  gameStore
    .checking3Game({
      play_id: item.platformId || item.playId || item.play_id,
    })
    .then((res: any) => {
      isCommit = false;
      if (res.response_code && res.response_code === '9999') {
        const payload: any = {
          play_id: item.platformId || item.play_id,
          params: item,
        };

        if (item.sub_play_id) {
          payload.type = item.play_name;
        }
        console.log('[三方彩票]:', item);
        // if (item.platformId === LotteryTypeIdEnum.tianCheng) {
        //   payload.type = item.code
        // }
        if (payload.play_id === LotteryTypeIdEnum.tianCheng) {
          payload.type = 'Lobby';
        }
        gameStore
          .get3GameUrl(payload)
          .then((res: any) => {
            closeToast();
            if (res && res.url) {
              const _urlInfo = transferThirdGameUrl(res.url, payload, item);
              goLinkGame(_urlInfo);
              // showConfirmDialog({
              //   message: mb_t('进入游戏'),
              //   className: 'enter3gameDialog',
              //   overlayClass: 'enter3gameDialogoverlay',
              //   showConfirmButton: true,
              //   showCancelButton: true,
              //   teleport: 'body',
              //   closeOnPopstate: true,
              //   closeOnClickOverlay: false,
              //   confirmButtonText: mb_t('确定'),
              //   cancelButtonText: mb_t('取消'),
              // })
              //   .then(() => {
              //     goLinkGame(_urlInfo);
              //   })
              //   .catch(() => {
              //     close3Game(payload.play_id);
              //   });
            } else {
              showFailToast(mb_t('未获取到三方平台地址'));
            }
          })
          .catch(err => {
            closeToast();
            mb_err(err.toString());
          });
      } else {
        closeToast();
      }
    })
    .catch(err => {
      closeToast();
      isCommit = false;
      if (err) {
        if (err.exMessage) {
          mb_err(err.exMessage.toString());
        } else if (err.info) {
          mb_err(err.info.toString());
        }
      }
    });
};
